import React from 'react'
import PropTypes from 'prop-types'
import assign from 'lodash/assign'
import { connect } from 'react-redux'
import { getBoundActions } from 'actions'
import ImmutablePropTypes from 'react-immutable-proptypes'
import SubcategoryDescriptionFull from 'components/SubcategoryDescriptionFull'
import ModalShare from 'components/Share'
import ModalLinkShare from 'components/ModalLinkShare'
import ModalPortalFlag from 'components/ModalPortalFlag'
import ModalViewAll from 'components/ModalViewAll'
import ModalRemoveUser from 'components/ModalRemoveUser'
import DialogUpdateProfileImage from 'components/DialogUpdateProfileImage'
import ModalCartChangePlan from 'components/CartV2/ModalCartChangePlan'
import ForgotPassword from 'components/ForgotPassword'
import ModalFreeTrialExpired from 'components/ModalFreeTrialExpired'
import ModalLiveAccessEmailCapture from 'components/ModalLiveAccessEmailCapture'
import ModalUnsavedChanges from 'components/Portal/ModalUnsavedChanges'
import ModalConfigurableVideo from 'components/Daytona/Campaigns/WA-10/ModalConfigurableVideo'
import ModalHideContent from 'components/ModalHideContent'
import ModalPauseError from 'components/AccountPause/ModalPauseError'
import ModalPauseResume from 'components/AccountPause/ModalPauseResume'
import ModalCookieCompliance from 'components/ModalCookieCompliance'
import ModalConfirm from 'components/ModalConfirm'
import MyAccountCancelModal from 'components/MyAccount/MyAccountCancelModal'
import MyAccountChangePlanModal from 'components/MyAccount/MyAccountChangePlanModal'
import MultiplePlaylistsShareModal from 'components/MultiplePlaylists/MultiplePlaylistsShareModal'
import MultiplePlaylistsShareTooltip from 'components/MultiplePlaylists/MultiplePlaylistsShareTooltip'
import MultiplePlaylistsAddModal from 'components/MultiplePlaylists/MultiplePlaylistsAddModal'
import MultiplePlaylistsAddModalGraphql from 'components/MultiplePlaylists/MultiplePlaylistsAddModal/MultiplePlaylistsAddModalGraphql'
import MultiplePlaylistsDeleteModal from 'components/MultiplePlaylists/MultiplePlaylistsDeleteModal'
import MultiplePlaylistsRenameModal from 'components/MultiplePlaylists/MultiplePlaylistsRenameModal'
import MyLibraryPlaylistDeleteModal from 'components/MyLibraryPage/MyLibraryPlaylistDeleteModal'
import MyLibraryPlaylistRenameModal from 'components/MyLibraryPage/MyLibraryPlaylistRenameModal'
import ModalGiftPeriodNotification from 'components/ModalGiftPeriodNotification/ModalGiftPeriodNotification'
import ModalGiftConfirm from 'components/Gift/ModalGiftConfirm'
import ModalGiftCreateAccount from 'components/Gift/ModalGiftCreateAccount'
import AnnouncementModal from 'components/Announcement/AnnouncementModal'
import NotificationsVideoPromotionModal from 'components/NotificationsVideoPromotion/NotificationsVideoPromotionModal'
import { GiftPlanSelect } from 'components/Gift/GiftPlanSelect'
import ModalCartAbandon from 'components/CartV2/ModalCartAbandon/ModalCartAbandon'
import ModalCartAbandonV2 from 'components/CartV2/ModalCartAbandonV2/ModalCartAbandonV2'
import CartSinglePageUpdateEmail from 'components/CartSinglePage/CartSinglePageUpdateEmail'
import HistoryContext from 'components/Router/HistoryContext'
import Modal from 'components/Modal'
import Login from 'components/Login'
import LoginWithCode from 'components/Login/LoginWithCode'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'
import Button, { TYPES } from 'components/Button'
import { get as getConfig } from 'config'

import {
  TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM,
  DIALOG_CLOSE_BUTTON_COLOR_WHITE,
  TYPE_LIVE_ACCESS_EMAIL_CAPTURE,
  TYPE_MULTIPLE_PROFILES_RM_USER,
  TYPE_SUBCATEGORY_DESCRIPTION,
  TYPE_USER_PLAYLIST_ADD_REMOVE,
  TYPE_USER_PLAYLIST_SHARE,
  TYPE_USER_PLAYLIST_TOOLTIP,
  TYPE_USER_PLAYLIST_DELETE,
  TYPE_USER_PLAYLIST_RENAME,
  TYPE_UPDATE_PROFILE_IMAGE,
  TYPE_GIFT_CREATE_ACCOUNT,
  TYPE_FREE_TRIAL_EXPIRED,
  TYPE_USER_PLAYLIST_ADD,
  TYPE_SELECT_GIFT_PLAN,
  TYPE_CART_CHANGE_PLAN,
  TYPE_FORGOT_PASSWORD,
  TYPE_SHARE_V2_SHARE,
  TYPE_DAYTONA_WA_10,
  TYPE_GIFT_CONFIRM,
  TYPE_ROW_VIEW_ALL,
  TYPE_HIDE_CONTENT,
  TYPE_CART_ABANDON,
  TYPE_PAUSE_RESUME,
  TYPE_PAUSE_ERROR,
  TYPE_PORTAL_EXIT,
  TYPE_PORTAL_FLAG,
  TYPE_LINK_SHARE,
  TYPE_CONFIRM,
  TYPE_LOGIN,
  TYPE_LOGIN_WITH_CODE,
  getProps,
  TYPE_GIFT_PERIOD_NOTIFICATION,
  TYPE_MY_ACCOUNT_CANCEL_MEMBERSHIP,
  TYPE_COOKIE_COMPLIANCE,
  TYPE_ANNOUNCEMENT_MODAL,
  TYPE_NOTIFICATION_VIDEO_PROMOTION,
  TYPE_CHECKOUT_UPDATE_EMAIL,
} from 'services/dialog'

function warnFocus () {
  if (process.env.BROWSER && window.console) {
    window.console.warn(`
      Modal dialog warning :: it is advised to provide an onReturnFocus handler to Modal for accessibility use.
      Provide a no-operation (noop) handler if you want no return functionality.
    `)
  }
}

function stopPropagation (e) {
  e.stopPropagation()
}

function getClassName (visible, customClass) {
  const className = ['dialog', 'dialog--visible']
  if (customClass) className.push(customClass)
  return className.join(' ')
}

function iconClass (color) {
  const cls = ['icon--overlay-close', 'dialog__close-icon']
  if (color === DIALOG_CLOSE_BUTTON_COLOR_WHITE) cls.push('dialog__close-icon--white')
  return cls.join(' ')
}

function renderChild (componentName, props) {
  const { dialog } = props
  const customMessage = dialog.getIn(['options', 'customMessage'])
  const checkoutEmail = dialog.getIn(['options', 'checkoutEmail'])
  const config = getConfig()

  switch (componentName) {
    case TYPE_LOGIN:
      return <Login loginDialogMessage={customMessage} checkoutEmail={checkoutEmail} />
    case TYPE_LOGIN_WITH_CODE:
      return <LoginWithCode />
    case TYPE_SHARE_V2_SHARE:
      return <ModalShare {...props} />
    case TYPE_DAYTONA_WA_10:
      return <ModalConfigurableVideo {...props} />
    case TYPE_LINK_SHARE:
      return <ModalLinkShare {...props} />
    case TYPE_MULTIPLE_PROFILES_RM_USER:
      return <ModalRemoveUser {...props} />
    case TYPE_LIVE_ACCESS_EMAIL_CAPTURE:
      return <ModalLiveAccessEmailCapture {...props} />
    case TYPE_FREE_TRIAL_EXPIRED:
      return <ModalFreeTrialExpired />
    case TYPE_PORTAL_FLAG:
      return <ModalPortalFlag {...props} />
    case TYPE_PORTAL_EXIT:
      return <ModalUnsavedChanges {...props} />
    case TYPE_ROW_VIEW_ALL:
      return <ModalViewAll {...props} />
    case TYPE_CART_CHANGE_PLAN:
      return <ModalCartChangePlan {...props} />
    case TYPE_UPDATE_PROFILE_IMAGE:
      return <DialogUpdateProfileImage />
    case TYPE_SUBCATEGORY_DESCRIPTION:
      return <SubcategoryDescriptionFull />
    case TYPE_FORGOT_PASSWORD:
      return <ForgotPassword {...props} />
    case TYPE_HIDE_CONTENT:
      return <ModalHideContent {...props} />
    case TYPE_PAUSE_ERROR:
      return <ModalPauseError {...props} />
    case TYPE_PAUSE_RESUME:
      return <ModalPauseResume {...props} />
    case TYPE_CONFIRM:
      return <ModalConfirm {...props} />
    case TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM:
      return <MyAccountChangePlanModal {...props} />
    case TYPE_MY_ACCOUNT_CANCEL_MEMBERSHIP:
      return <MyAccountCancelModal {...props} />
    case TYPE_USER_PLAYLIST_ADD:
      return <MultiplePlaylistsAddModal {...props} />
    case TYPE_USER_PLAYLIST_SHARE:
      return <MultiplePlaylistsShareModal {...props} />
    case TYPE_USER_PLAYLIST_TOOLTIP:
      return <MultiplePlaylistsShareTooltip {...props} />
    case TYPE_USER_PLAYLIST_DELETE:
      return config.features.myLibraryPageGraphQL
        ? <MyLibraryPlaylistDeleteModal {...props} />
        : <MultiplePlaylistsDeleteModal {...props} />
    case TYPE_USER_PLAYLIST_RENAME:
      return config.features.myLibraryPageGraphQL
        ? <MyLibraryPlaylistRenameModal {...props} />
        : <MultiplePlaylistsRenameModal {...props} />
    case TYPE_USER_PLAYLIST_ADD_REMOVE:
      return <MultiplePlaylistsAddModalGraphql {...props} />
    case TYPE_SELECT_GIFT_PLAN:
      return <GiftPlanSelect {...props} />
    case TYPE_CART_ABANDON:
      return config.features.modalCartAbandonV2
        ? <ModalCartAbandonV2 {...props} />
        : <ModalCartAbandon {...props} />
    case TYPE_COOKIE_COMPLIANCE:
      return <ModalCookieCompliance {...props} />
    case TYPE_GIFT_CONFIRM:
      return <ModalGiftConfirm {...props} />
    case TYPE_GIFT_CREATE_ACCOUNT:
      return <ModalGiftCreateAccount {...props} />
    case TYPE_GIFT_PERIOD_NOTIFICATION:
      return <ModalGiftPeriodNotification {...props} />
    case TYPE_ANNOUNCEMENT_MODAL:
      return <AnnouncementModal {...props} />
    case TYPE_NOTIFICATION_VIDEO_PROMOTION:
      return <NotificationsVideoPromotionModal {...props} />
    case TYPE_CHECKOUT_UPDATE_EMAIL:
      return <CartSinglePageUpdateEmail {...props} />
    default:
      return null
  }
}

class Dialog extends React.Component {
  onDismissOverlay = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { props } = this
    const {
      dialog,
      dismissModal,
      modalFreeTrialExpiredDismissed,
    } = props
    const name = dialog.get('componentName')
    const closeOnClick = dialog.get('closeOnClick')

    if (name === TYPE_FREE_TRIAL_EXPIRED) {
      modalFreeTrialExpiredDismissed(true)
    }

    if (closeOnClick !== false) {
      dismissModal(true)
    }
  }

  onDismiss = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { props } = this
    const {
      dialog,
      dismissModal,
      modalFreeTrialExpiredDismissed,
    } = props
    const name = dialog.get('componentName')
    const extProps = getProps(name)
    const { onDismiss } = extProps

    if (name === TYPE_FREE_TRIAL_EXPIRED) {
      modalFreeTrialExpiredDismissed(true)
    }

    if (onDismiss) onDismiss(e)
    dismissModal(name)
  }

  renderLegacyDialog (content, className = '') {
    const { props } = this
    const { dialog } = props
    const hideCloseButton = dialog.getIn(['options', 'hideCloseButton'], false)
    const customClass = dialog.getIn(['options', 'customClass'], className)
    const btnColor = dialog.getIn(['options', 'closeButtonColor'], null)

    return (
      <div className={'dialog-overlay'} onClick={this.onDismissOverlay}>
        {/* eslint-disable-next-line */}
        <section
          className={getClassName(true, customClass)}
          onClick={stopPropagation}
          aria-modal="true"
          role="dialog"
        >
          <div className="dialog__content">{content}</div>
          {hideCloseButton ? null : (
            <Button
              type={TYPES.LINK}
              onClick={this.onDismiss}
              className={iconClass(btnColor)}
            >
              <IconV2
                type={ICON_TYPES.CLOSE}
              />
            </Button>
          )}
        </section>
      </div>
    )
  }

  renderModal (content, extProps) {
    const {
      onReturnFocus = warnFocus,
      hideDismiss = false,
      className = '',
      title = '',
      hideOverflow = false,
      type = null,
    } = extProps
    return (
      <Modal
        visible
        title={title}
        className={className}
        hideDismiss={hideDismiss}
        onDismiss={this.onDismiss}
        onReturnFocus={onReturnFocus}
        hideOverflow={hideOverflow}
        type={type}
      >
        {content}
      </Modal>
    )
  }

  render () {
    const { props, context: history } = this
    const { dialog, location, dismissModal } = props
    const name = dialog.get('componentName', '')
    const asModal = dialog.get('asModal', false)

    if (name) {
      let className

      if (name === TYPE_CART_CHANGE_PLAN) {
        className = 'modal--modal-cart-change-plan'
      }

      if (name === TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM) {
        className = 'modal--my-account-change-plan'
      }

      if (name === TYPE_USER_PLAYLIST_ADD
        || name === TYPE_USER_PLAYLIST_ADD_REMOVE
        || name === TYPE_USER_PLAYLIST_DELETE
        || name === TYPE_USER_PLAYLIST_RENAME
        || name === TYPE_USER_PLAYLIST_SHARE) {
        className = 'modal--multiple-playlists'
      }

      if (name === TYPE_USER_PLAYLIST_SHARE) {
        className += ' modal--share-playlist'
      }

      if (name === TYPE_CART_ABANDON) {
        className = 'modal--cart-abandon'
      }

      if (name === TYPE_SELECT_GIFT_PLAN) {
        className = 'modal--fullscreen'
      }

      if (name === TYPE_LOGIN) {
        className = 'modal--login'
      }

      if (name === TYPE_COOKIE_COMPLIANCE) {
        className = 'modal--cookie-compliance'
      }

      if (name === TYPE_CHECKOUT_UPDATE_EMAIL) {
        className = 'modal--checkout-update-email'
      }

      const extProps = assign({}, getProps(name), {
        location, history, dismissModal, className, dialog,
      })
      const content = renderChild(name, extProps)
      if (content) {
        return asModal
          ? this.renderModal(content, extProps) // NEW HOTNESS
          : this.renderLegacyDialog(content, className) // LEGACY DIALOG - DEPRICATED
      }
    }
    return null
  }
}

Dialog.propTypes = {
  dialog: ImmutablePropTypes.map.isRequired,
  dismissModal: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
}

Dialog.contextType = HistoryContext

export default connect(
  (state) => ({
    optimizely: state.optimizely,
    dialog: state.dialog,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      dismissModal: actions.dialog.dismissModal,
      modalFreeTrialExpiredDismissed: actions.user.modalFreeTrialExpiredDismissed,
    }
  },
)(Dialog)
